import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer,
    Cell,
    CartesianGrid,

} from "recharts";
import { Card, Col, Row, CardHeader, CardBody, CardFooter, Button, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { usePagination } from "../../hooks/usePagination";
import DateTimePicker from 'react-datepicker'
import { useEffect, useState } from "react";
import { format } from "date-fns";
import ApiService from "../../services/apiService";
import PumpingStation from "../PumpingStation/PumpingStation";
import { toast } from "react-toastify";
import LeftIcon from "../svg/LeftButton";
import RightIcon from "../svg/RightIcon";

type chartProp = {
    fromDateTime?: string | null;
    toDateTime?: string | null;
    generateKey?: number | null | undefined;
    id?: number | string;
    selectedDashboard?: string|null

};

const BarChart2 = ({ fromDateTime, toDateTime, generateKey, id,selectedDashboard }: chartProp) => {

    const [isEnabled, setIsEnabled] = useState<boolean>(false)
    const [powerConsumptionData, setPowerConsumptionData] = useState<any[]>([])
    const [pumpingstation, setPumpingStation] = useState<any[]>()
    const [selectedPumpingStation, setSelectedPumpingStation] = useState<string>('')
    const [dropdownOpen, setDropdownOpen] = useState<boolean>()

    const [startIndex, setStartIndex] = useState(0);
    const windowSize = 10; // show 10 bars at a time

    const endDate = new Date();
    const startDate = new Date();
    startDate.setDate(startDate.getDate() - 7); 
    startDate.setHours(0, 0, 0, 0);


    /*const handleClick = () => {
        setPumpingStationId(2);

        if (fromDateTime) {
            const from = format(fromDateTime, 'yyyy-MM-dd HH:mm:ss')
            setFromDate(from)
        }

        if (toDateTime) {
            const to = format(toDateTime, 'yyyy-MM-dd HH:mm:ss')
            setToDate(to)
        }

        setIsEnabled(true)
        setRefresh(prev => prev)

    }*/



    const toggleDropdown = () => setDropdownOpen(prev => !prev)

    useEffect(() => {
        const getPumpingStation = async () => {
            try {
                const response = await ApiService.axiosApi(`/pumpingstation`, {
                    method: 'GET',
                    params: {
                        pageNumber: 0,
                        pageSize: 0
                    }
                })

                if (response.success) {
                    setPumpingStation(response.data.data)
                } else {
                    console.log('Unable to get  pumping station ')
                }
            } catch (error) {
                console.log(error)
            }
        }

        getPumpingStation();

    }, [])



    const getPowerConsumption = async () => {
        try {
            const response = await ApiService.axiosApi(`/powerconsumption`, {
                method: 'GET',
                params: {
                    PumpingStationId: id ? id : 2,
                    pageNumber: 0,
                    pageSize: 0,
                    fromDate: fromDateTime == null ? format(startDate, 'yyyy-MM-dd HH:mm:ss') : format(fromDateTime, 'yyyy-MM-dd HH:mm:ss'),
                    toDate: toDateTime == null ? format(endDate, 'yyyy-MM-dd HH:mm:ss') : format(toDateTime, 'yyyy-MM-dd HH:mm:ss')
                }
            })
            if (response.success) {
                setPowerConsumptionData(response.data.data)
            } else {
               
                    
                toast.error('Unable to find data at this moment')
            }
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        getPowerConsumption();
    }, [generateKey])



    const handleNext = () => {
        if (powerConsumptionData && startIndex + windowSize < powerConsumptionData.length) {
            setStartIndex(startIndex + windowSize);
        }
    };

    const handlePrev = () => {
        if (startIndex - windowSize >= 0) {
            setStartIndex(startIndex - windowSize);
        }
    };

    const visibleData = powerConsumptionData?.slice(startIndex, startIndex + windowSize) || [];

    return (

        <Col style={{ height: '100%' }}>


            <Card className="m-0 b-r-0 ">


                <CardHeader>
                    <div className="d-flex justify-content-between align-items-center">



                        <span>
                         <h5 style={{ fontWeight: '600' }}>Power Consumption</h5>
                         <h6 style={{fontSize:'12px'}}> {fromDateTime ? format(new Date(fromDateTime), "dd/MM/yyyy ") : format(startDate,"dd/MM/yyyy ")} -
                         {toDateTime ? format(new Date(toDateTime), "dd/MM/yyyy ") : format(endDate,"dd/MM/yyyy ")}</h6>
                         </span>

                        <div className='d-flex'>
                           
                            <button className="icon-button " onClick={handlePrev} disabled={startIndex === 0}><LeftIcon/></button>
                            
                            <button className="icon-button" onClick={handleNext} disabled={startIndex + windowSize >= powerConsumptionData.length}><RightIcon/></button>
                        </div>

                        { /*<div className='d-flex justify-around'>

                        <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown} className="custom-dropdown-wrapper">
                             <DropdownToggle
                                className="custom-dropdown-toggle d-flex align-items-center justify-content-between report-dropdown"

                                style={{
                                    backgroundColor: '#007bff',
                                    borderColor: '#007bff',
                                    color: '#fff',
                                    fontWeight: 500,
                                    borderRadius: '5px',
                                    padding: '8px 16px',
                                    maxWidth: '150px'
                                }}
                                color="primary"
                            >
                                {selectedPumpingStation ? selectedPumpingStation : "Select  Station"}
                            </DropdownToggle>

                            <DropdownMenu
                                className="custom-dropdown-menu"
                                style={{

                                    overflowY: 'auto',
                                    boxShadow: '0 0.5rem 1rem rgba(0, 0, 0, 0.1)',
                                    borderRadius: '8px',
                                    padding: '8px 0',
                                }}
                            >
                                {pumpingstation?.map((data: any) => (
                                    <DropdownItem onClick={() => {
                                        setId(data.id)
                                        setSelectedPumpingStation(data.name)
                                        

                                    }} key={data.id}>
                                        {data.includeInDashboard == true ? data.name : ''}
                                    </DropdownItem>
                                ))}
                            </DropdownMenu>
                        </Dropdown>

                            <div className=" mx-2  d-flex flex-column ">

                                <DateTimePicker
                                    className="dashboard-input"
                                    dateFormat="dd/MM/yyyy HH:mm:ss"
                                    placeholderText="DD-MM-YYYY"
                                    showTimeSelect
                                    onChange={(date: any) => setFromDateTime(date)}
                                    selected={fromDateTime}
                                    isClearable
                                    timeFormat="HH:mm:ss"
                                />
                            </div>


                            <div className=" mx-2  d-flex flex-column">

                                <DateTimePicker
                                    className="dashboard-input"
                                    dateFormat="dd/MM/yyyy HH:mm:ss"
                                    placeholderText="DD-MM-YYYY"
                                    showTimeSelect
                                    onChange={(date: any) => setToDateTime(date)}
                                    selected={toDateTime}
                                    isClearable
                                    timeFormat="HH:mm:ss"
                                />
                            </div>
                            <div>

                                <Button color="success" className="button-dashboard mx-2 px-1 py-1" onClick={getPowerConsumption}>
                                    Generate
                                </Button>

                            </div>
                        </div> */}


                    </div>


                </CardHeader>

                <CardBody>


                    <ResponsiveContainer width="100%" height={300} >
                        <BarChart
                            data={visibleData}
                            barCategoryGap='0%'
                            barGap='1'

                        >

                            <XAxis dataKey="dateTime" padding={{ left: 5, right: 5 }} 
                            tick={{ fontSize: 15, textAnchor: 'centre' }} 
                            tickMargin={5}          
                            interval={1}
                            tickFormatter={(value) => {
                              const date = new Date(value);
                              return date.toLocaleString("en-GB", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                               
                              });
                            }}
                            />
                            <YAxis
                                domain={[0, 100]} />



                            <Tooltip formatter={(KWH: number, name: string) => [`${KWH}`, name]}
                                cursor={false}
                                contentStyle={{
                                    backgroundColor: "white", // Tooltip box color
                                    borderRadius: "4px",
                                    border: "1px solid #ddd",
                                    boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                                }}

                                labelFormatter={(value) => {
                                    const date = new Date(value);
                                    return format(date, "dd/MM/yyyy"); // no T
                                  }}

                            />

                            <Bar
                                dataKey="powerConsumption_KWH"
                                animationDuration={600}
                                label={{ position: "top" }}
                                radius={[0, 0, 0, 0]}
                                barSize={30}
                                fill="#2B5F60"

                            >

                                {powerConsumptionData?.map((entry: any, index) => (
                                    <Cell key={`cell-${index}`} />
                                ))}

                            </Bar>


                        </BarChart>
                    </ResponsiveContainer>
                </CardBody>


            </Card>

        </Col>

    )
}

export default BarChart2